import { render, staticRenderFns } from "./CustomerDialog.vue?vue&type=template&id=6dbf346e"
import script from "./CustomerDialog.vue?vue&type=script&lang=js"
export * from "./CustomerDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerDialog.vue?vue&type=style&index=0&id=6dbf346e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports